// @ts-nocheck
import { Plugin } from '/home/jenkins/workspace/fe-storemap-h5-online/relx-map/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','getInitialState','initialStateConfig','request',],
});

export { plugin };
